import { render, staticRenderFns } from "./VehicleItemPage.vue?vue&type=template&id=c9efed4e&scoped=true&"
import script from "./VehicleItemPage.vue?vue&type=script&lang=js&"
export * from "./VehicleItemPage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleItemPage.vue?vue&type=style&index=0&id=c9efed4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9efed4e",
  null
  
)

export default component.exports